import React, { useState, useEffect, useRef } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import './NotificationCenter.scss';

const NotificationCenter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);
  const { notifications, markAsRead, clearAllNotifications } = useNotifications();

  useEffect(() => {
    // Atualiza o contador de notificações não lidas
    setUnreadCount(notifications.filter(notif => !notif.read).length);
  }, [notifications]);

  useEffect(() => {
    // Fecha o dropdown quando clica fora
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleNotificationClick = (id) => {
    markAsRead(id);
  };

  const handleClearAll = () => {
    clearAllNotifications();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR');
  };

  return (
    <div className="notification-center" ref={dropdownRef}>
      <button className="notification-bell" onClick={toggleDropdown}>
        <i className="fas fa-bell"></i>
        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
      </button>
      
      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h3>Notificações</h3>
            {notifications.length > 0 && (
              <button className="clear-all-btn" onClick={handleClearAll}>
                Limpar tudo
              </button>
            )}
          </div>
          
          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="empty-notification">
                <p>Nenhuma notificação</p>
              </div>
            ) : (
              notifications.map((notif) => (
                <div 
                  key={notif.id} 
                  className={`notification-item ${!notif.read ? 'unread' : ''}`}
                  onClick={() => handleNotificationClick(notif.id)}
                >
                  <div className="notification-icon">
                    <i className={`fas ${notif.type === 'success' ? 'fa-check-circle' : 
                                        notif.type === 'info' ? 'fa-info-circle' : 
                                        notif.type === 'reminder' ? 'fa-clock' : 'fa-pills'}`}></i>
                  </div>
                  <div className="notification-content">
                    <div className="notification-title">{notif.title}</div>
                    <div className="notification-message">{notif.message}</div>
                    <div className="notification-time">{formatDate(notif.time)}</div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter; 